import React, { useState, } from 'react';
import StatusReport from './StatusReport';
import './Autopay.css';

export default function AutopayView() {
  const [ formData, setFormData, ] = useState(null);

  const formSubmit = (e) => {
    e.preventDefault();
    const formDataObj = Object.fromEntries((new FormData(e.target)).entries());
    formDataObj.key = Math.random();
    setFormData(formDataObj);
  };

  return (
    <div className="atp-status">
      <form id="atp-status-form" onSubmit={formSubmit}>
        <div>
          <label htmlFor="atp-status-soid">
            Service Offering ID:
            <input id="atp-status-soid" type="text" name="serviceOfferingId" required />
          </label>
        </div>
        <div>
          <label htmlFor="atp-status-date">
            Due Date:
            <input id="atp-status-date" type="date" name="dueDate" required />
          </label>
        </div>
        <div>
          <input type="submit" value="Search" />
        </div>
        <div>
          <a
            className="atp-status-guide"
            target="_blank"
            rel="noopener noreferrer"
            href="https://payitdev.atlassian.net/wiki/spaces/PAYM/pages/4254367788/Autopay+Reports"
          >
            Guide for understanding this report is available here
          </a>
        </div>
      </form>
      <hr />
      {formData ? <StatusReport {...formData} /> : '' }
    </div>
  );
}
